import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FieldLike } from './utils';
import { DateField } from './schedule_utils';
import { fetchContractManagementDetails } from '../../actions/additional_actions';
import { getDateValue } from '../../utils/date';
import { fetchPermissionsByModule } from '../../actions/project_actions';

class ContractManagementDetailsForm extends Component {
    // static PropTypes = {
    //     onSubmit: PropTypes.func.isRequired,
    //     onCancel: PropTypes.func.isRequired,
    //     info: PropTypes.object.isRequired,
    //     setup: PropTypes.object.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            cmDetail: {},
            contract: {},
            activeTab: 'scope',
            isOpen: false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);

        const today = new Date();
        const targetYear = today.getFullYear() + 7;
        this.fiscalYears = [];

        let year;
        for (year = 2008; year <= targetYear; year++)
            this.fiscalYears.push({ label: year, value: year });
    }

    UNSAFE_componentWillMount() {
        const { cmDetail } = this.props;
        this.setState({ cmDetail: cmDetail })
        this.props.fetchPermissionsByModule(this.props.projectId);
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }

    handleCancel(e) {
        e.preventDefault();

        this.props.onCancel();
    }

    handleSubmit(e) {
        e.preventDefault();
        const { cmDetail } = this.state;
        this.setState({ cmDetail });
        this.props.onSubmit(cmDetail);
    }

    handleCheckboxChange(name) {
        return (e) => {
            const cmDetail = this.state.cmDetail;

            if (cmDetail[name] === true)
                cmDetail[name] = false;
            else
                cmDetail[name] = true;

            this.setState({ cmDetail });
        }
    }

    handleDateChange(name) {
        return (date) => {

            const cmDetail = { ...this.state.cmDetail, [name]: date }
            this.setState({ cmDetail });
        }
    }

    renderSelectCritical() {
        return (
            <div className="controls-padding">
                <label className="label-radio">Critical</label>
                <div>
                    <div className="md-radio md-radio-inline">
                        <input id="3" type="radio" checked={this.state.info['critical']} onChange={this.handleCheckboxChange('critical')} />
                        <label htmlFor="3">Yes</label>
                    </div>
                    <div className="md-radio md-radio-inline">
                        <input id="4" type="radio" checked={!this.state.info['critical']} onChange={this.handleCheckboxChange('critical')} />
                        <label htmlFor="4">No</label>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { cmDetail } = this.state;
        const { isCSUDir } = this.props.permissionsModule;
        let canSubmit = true;

        return (

            <form onSubmit={this.handleSubmit}>

                <div className="row static-modal-fields">
                    {this.props.contract.contractType.includes('Force Account/') ?
                        <div id="csbform">
                            {isCSUDir ?
                                <div className="col l4 m3 s12">
                                    <div className="controls date-control fixed-datePicker">
                                        <span className='label'>Contract Close Out</span>
                                        <DateField name="cntrctClsoutDt"
                                            value={cmDetail.cntrctClsoutDt}
                                            limits={{}}
                                            onChange={this.handleDateChange('cntrctClsoutDt')}
                                        />
                                    </div>
                                </div>
                                : <div className="col l4 m3 s6">
                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                </div>
                            }
                        </div>
                        : null}

                    {this.props.contract.contractType.includes('Construction/') ?
                        <div id="csbform">
                            {this.props.contract.divisionName === 'Infrastructure' ?
                                <div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Substantial Inspection</span>
                                            <DateField name="substntlInspcDt"
                                                value={cmDetail.substntlInspcDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('substntlInspcDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Actual Substantial Completion</span>
                                            <DateField name="actSubstntlCmpltnDt"
                                                value={cmDetail.actSubstntlCmpltnDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('actSubstntlCmpltnDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Final Completion</span>
                                            <DateField name="finalCompltnDt"
                                                value={cmDetail.finalCompltnDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('finalCompltnDt')}
                                            />
                                        </div>
                                    </div>
                                    {isCSUDir && this.props.contract.divisionName === 'Infrastructure'
                                        ? <div className="col l4 m3 s12">
                                            <div className="controls date-control fixed-datePicker">
                                                <span className='label'>Contract Close Out</span>
                                                <DateField name="cntrctClsoutDt"
                                                    value={cmDetail.cntrctClsoutDt}
                                                    limits={{}}
                                                    onChange={this.handleDateChange('cntrctClsoutDt')}
                                                />
                                            </div>
                                        </div>
                                        : <div className="col l4 m3 s6">
                                            <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                        </div>
                                    }
                                </div>
                                :
                                <div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Projected Construction Start</span>
                                            <DateField name="prjctdCnstrctnStrtDt"
                                                value={cmDetail.prjctdCnstrctnStrtDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('prjctdCnstrctnStrtDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Actual Construction Start</span>
                                            <DateField name="actCnstrctnStrtDt"
                                                value={cmDetail.actCnstrctnStrtDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('actCnstrctnStrtDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Substantial Inspection</span>
                                            <DateField name="substntlInspcDt"
                                                value={cmDetail.substntlInspcDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('substntlInspcDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Projected Substantial Completion</span>
                                            <DateField name="prjctdSubstntlInspcDt"
                                                value={cmDetail.prjctdSubstntlInspcDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('prjctdSubstntlInspcDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Actual Substantial Completion</span>
                                            <DateField name="actSubstntlCmpltnDt"
                                                value={cmDetail.actSubstntlCmpltnDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('actSubstntlCmpltnDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls">
                                            <label className="label-radio">Punch List</label>
                                            <div>
                                                <div className="md-radio md-radio-inline">
                                                    <input id="3" type="radio" checked={cmDetail['punchLst']} onChange={this.handleCheckboxChange('punchLst')} />
                                                    <label htmlFor="3">Yes</label>
                                                </div>
                                                <div className="md-radio md-radio-inline">
                                                    <input id="4" type="radio" checked={!cmDetail['punchLst']} onChange={this.handleCheckboxChange('punchLst')} />
                                                    <label htmlFor="4">No</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Guarantee Start</span>
                                            <DateField name="grntStrtDt"
                                                value={cmDetail.grntStrtDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('grntStrtDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Guarantee End</span>
                                            <DateField name="grntEndDt"
                                                value={cmDetail.grntEndDt}
                                                limits={{ dateAbove: cmDetail.grntStrtDt }}
                                                onChange={this.handleDateChange('grntEndDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Final Inspection</span>
                                            <DateField name="finalInspctnDt"
                                                value={cmDetail.finalInspctnDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('finalInspctnDt')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col l4 m3 s12">
                                        <div className="controls date-control fixed-datePicker">
                                            <span className='label'>Final Completion</span>
                                            <DateField name="finalCompltnDt"
                                                value={cmDetail.finalCompltnDt}
                                                limits={{}}
                                                onChange={this.handleDateChange('finalCompltnDt')}
                                            />
                                        </div>
                                    </div>
                                    {isCSUDir
                                        ? <div className="col l4 m3 s12">
                                            <div className="controls date-control fixed-datePicker">
                                                <span className='label'>Contract Close Out</span>
                                                <DateField name="cntrctClsoutDt"
                                                    value={cmDetail.cntrctClsoutDt}
                                                    limits={{}}
                                                    onChange={this.handleDateChange('cntrctClsoutDt')}
                                                />
                                            </div>
                                        </div>
                                        : <div className="col l4 m3 s6">
                                            <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        : null}


                    {(!this.props.contract.contractType.includes('Construction/') && !this.props.contract.contractType.includes('Force Account/')) ?
                        <div id="csbform">
                            {this.props.contract.divisionName === 'Public Buildings' ?
                                <div>
                                    {this.props.contract.contractType.includes('/JOCS/') ?
                                        <div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Projected Construction Start</span>
                                                    <DateField name="prjctdCnstrctnStrtDt"
                                                        value={cmDetail.prjctdCnstrctnStrtDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('prjctdCnstrctnStrtDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Actual Construction Start</span>
                                                    <DateField name="actCnstrctnStrtDt"
                                                        value={cmDetail.actCnstrctnStrtDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('actCnstrctnStrtDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Substantial Inspection</span>
                                                    <DateField name="substntlInspcDt"
                                                        value={cmDetail.substntlInspcDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('substntlInspcDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Projected Substantial Completion</span>
                                                    <DateField name="prjctdSubstntlInspcDt"
                                                        value={cmDetail.prjctdSubstntlInspcDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('prjctdSubstntlInspcDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Actual Substantial Completion</span>
                                                    <DateField name="actSubstntlCmpltnDt"
                                                        value={cmDetail.actSubstntlCmpltnDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('actSubstntlCmpltnDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls">
                                                    <label className="label-radio">Punch List</label>
                                                    <div>
                                                        <div className="md-radio md-radio-inline">
                                                            <input id="3" type="radio" checked={cmDetail['punchLst']} onChange={this.handleCheckboxChange('punchLst')} />
                                                            <label htmlFor="3">Yes</label>
                                                        </div>
                                                        <div className="md-radio md-radio-inline">
                                                            <input id="4" type="radio" checked={!cmDetail['punchLst']} onChange={this.handleCheckboxChange('punchLst')} />
                                                            <label htmlFor="4">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Guarantee Start</span>
                                                    <DateField name="grntStrtDt"
                                                        value={cmDetail.grntStrtDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('grntStrtDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Guarantee End</span>
                                                    <DateField name="grntEndDt"
                                                        value={cmDetail.grntEndDt}
                                                        limits={{ dateAbove: cmDetail.grntStrtDt }}
                                                        onChange={this.handleDateChange('grntEndDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Final Inspection</span>
                                                    <DateField name="finalInspctnDt"
                                                        value={cmDetail.finalInspctnDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('finalInspctnDt')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Final Completion</span>
                                                    <DateField name="finalCompltnDt"
                                                        value={cmDetail.finalCompltnDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('finalCompltnDt')}
                                                    />
                                                </div>
                                            </div>
                                            {isCSUDir
                                                ? <div className="col l4 m3 s12">
                                                    <div className="controls date-control fixed-datePicker">
                                                        <span className='label'>Contract Close Out</span>
                                                        <DateField name="cntrctClsoutDt"
                                                            value={cmDetail.cntrctClsoutDt}
                                                            limits={{}}
                                                            onChange={this.handleDateChange('cntrctClsoutDt')}
                                                        />
                                                    </div>
                                                </div>
                                                : <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div>
                                            {isCSUDir
                                                ? <div className="col l4 m3 s12">
                                                    <div className="controls date-control fixed-datePicker">
                                                        <span className='label'>Contract Close Out</span>
                                                        <DateField name="cntrctClsoutDt"
                                                            value={cmDetail.cntrctClsoutDt}
                                                            limits={{}}
                                                            onChange={this.handleDateChange('cntrctClsoutDt')}
                                                        />
                                                    </div>
                                                </div>
                                                : <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                :

                                <div>
                                    {this.props.contract.contractType.includes('/JOCS/') ?
                                        <div>
                                            <div className="col l4 m3 s12">
                                                <div className="controls date-control fixed-datePicker">
                                                    <span className='label'>Substantial Inspection</span>
                                                    <DateField name="substntlInspcDt"
                                                        value={cmDetail.substntlInspcDt}
                                                        limits={{}}
                                                        onChange={this.handleDateChange('substntlInspcDt')}
                                                    />
                                                </div>
                                            </div>
                                            {isCSUDir && this.props.contract.divisionName === 'Infrastructure' ?
                                                <div className="col l4 m3 s12">
                                                    <div className="controls date-control fixed-datePicker">
                                                        <span className='label'>Contract Close Out</span>
                                                        <DateField name="cntrctClsoutDt"
                                                            value={cmDetail.cntrctClsoutDt}
                                                            limits={{}}
                                                            onChange={this.handleDateChange('cntrctClsoutDt')}
                                                        />
                                                    </div>
                                                </div>
                                                : <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                                </div>}
                                        </div> :
                                        <div>

                                            {isCSUDir && this.props.contract.divisionName === 'Infrastructure' ?
                                                <div className="col l4 m3 s12">
                                                    <div className="controls date-control fixed-datePicker">
                                                        <span className='label'>Contract Close Out</span>
                                                        <DateField name="cntrctClsoutDt"
                                                            value={cmDetail.cntrctClsoutDt}
                                                            limits={{}}
                                                            onChange={this.handleDateChange('cntrctClsoutDt')}
                                                        />
                                                    </div>
                                                </div>
                                                : <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail.cntrctClsoutDt)} />
                                                </div>}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        : null}
                </div>

                <div className="section-buttons" id="sectionBtnsInfo">
                    <span className="btn-cancel" onClick={this.handleCancel}>Cancel</span>
                    <button className="btn-save" disabled={!canSubmit}>Save</button>
                </div>
            </form>
        );
    }
}

ContractManagementDetailsForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    info: PropTypes.object.isRequired,
    setup: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        projectId: ownProps.projectId,
        permissionsModule: state.projectsStore.permissionsModule,
    }
}

export default connect(mapStateToProps, { fetchContractManagementDetails, fetchPermissionsByModule })(ContractManagementDetailsForm);